import { createStore } from "vuex";
import quotationStore from "../pages/eqa/quotation/store";
import Api from "../services";

const Store = createStore({
  state: {
    loading: false,
    media_url: process.env.VUE_APP_API_URL,
    documents: [],
    categories: [],
    trainings: [],
    pastTrainings: [],
    conferences: [],
    mentorship: {},
    aboutData: {},
    distributors: [],
  },
  mutations: {
    setLoading(state, n) {
      state.loading = n;
    },
    setDocuments(state, documents) {
      state.documents = documents;
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    setTrainings(state, trainings) {
      state.trainings = trainings;
    },
    setPastTrainings(state, pastTrainings) {
      state.pastTrainings = pastTrainings;
    },
    setConferences(state, conferences) {
      state.conferences = conferences;
    },
    setMentorship(state, mentorship) {
      state.mentorship = mentorship;
    },
    setAboutData(state, aboutData) {
      state.aboutData = aboutData;
    },
    setDistributors(state, distributors) {
      state.distributors = distributors;
    },
  },
  actions: {
    fetchDocuments({ commit, state }) {
      if (state.documents.length === 0) {
        return Api.documents.get().then((res) => {
          commit("setDocuments", res.data);
        });
      }
    },
    fetchCategories({ commit, state }) {
      if (state.categories.length === 0) {
        return Api.categories.get().then((res) => {
          commit("setCategories", res.data);
        });
      }
    },
    fetchTrainings({ commit, state }, now) {
      if (state.trainings.length === 0) {
        return Api.training.get(`?end_date_gte=${now}&_sort=start_date:ASC`).then((res) => {
          commit("setTrainings", res.data);
        });
      }
    },
    fetchPastTrainings({ commit, state }, now) {
      if (state.pastTrainings.length === 0) {
        return Api.training.get(`?end_date_lt=${now}&_sort=start_date:DESC`).then((res) => {
          commit("setPastTrainings", res.data);
        });
      }
    },
    fetchConferences({ commit, state }) {
      if (state.conferences.length === 0) {
        return Api.conferences.get("?_sort=start_date:desc").then((res) => {
          commit("setConferences", res.data);
        });
      }
    },
    fetchMentorship({ commit, state }) {
      if (!state.mentorship.title) {
        return Api.mentorship.get().then((res) => {
          commit("setMentorship", res.data);
        });
      }
    },
    fetchAbout({ commit, state }) {
      if (!state.aboutData.intro) {
        return Api.about.get().then((res) => {
          commit("setAboutData", res.data);
        });
      }
    },
    fetchDistributors({ commit, state }) {
      if (state.distributors.length === 0) {
        return Api.distributors.get("?_sort=order:ASC&_limit=50").then((res) => {
          commit("setDistributors", res.data);
        });
      }
    },
  },
  getters: {
    media_url: (state) => {
      return state.media_url;
    },
    loading: (state) => {
      return state.loading;
    },
    documents: (state) => {
      return [...state.documents].sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    categories: (state) => state.categories,
    trainings: (state) => state.trainings,
    pastTrainings: (state) => state.pastTrainings,
    conferences: (state) => state.conferences,
    mentorship: (state) => state.mentorship,
    aboutData: (state) => state.aboutData,
    distributors: (state) => state.distributors,
  },
  modules: {
    quotations: quotationStore,
  },
});

export default Store;
